import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => {
  const { primary } = theme.palette;

  return {
    examIcon: {
      color: "#21c37f"
    },
    exam: {
      color: "#21c37f",
      minWidth: 128,
      height: 28,
      fontSize: 14,
      "& .MuiButton-iconSizeSmall > *:first-child": {
        fontSize: 20
      },
      "&.Mui-disabled": {
        color: primary.light,
        "& .MuiButton-iconSizeSmall > *:first-child": {
          color: primary.light
        }
      }
    }
  };
});
